export const CREDIT_CARDS = [
    {
        id: 1,
        name: "TD First Class Travel® Visa Infinite* Card",
        issuer: "TD",
        annualFee: 139,
        earnRate: "8x TD Rewards points on Expedia for TD",
        welcomeBonus: "Up to 135,000 TD Rewards Points",
        minIncome: 60000,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 0.5,
        foreignFee: 2.5
    },
    {
        id: 2,
        name: "RBC® British Airways Visa Infinite†",
        issuer: "RBC",
        annualFee: 165,
        earnRate: "2x Avios on British Airways",
        welcomeBonus: "Up to 60,000 Avios",
        minIncome: 60000,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 2.0,
        foreignFee: 2.5
    },
    {
        id: 3,
        name: "CIBC Aeroplan® Visa* Business Card",
        issuer: "CIBC",
        annualFee: 180,
        earnRate: "1.5x Aeroplan points on travel and shipping",
        welcomeBonus: "Up to 75,000 Aeroplan points",
        minIncome: 35000,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 2.1,
        foreignFee: 2.5
    },
    {
        id: 4,
        name: "Business Platinum Card from American Express",
        issuer: "American Express",
        annualFee: 799,
        earnRate: "1.25x MR points on everything",
        welcomeBonus: "Up to 130,000 MR points",
        minIncome: 0,
        tier: "S",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 2.2,
        foreignFee: 2.5
    },
    {
        id: 5,
        name: "American Express Gold Rewards Card",
        issuer: "American Express",
        annualFee: 250,
        earnRate: "2x MR points on travel, gas, grocery, drugstore",
        welcomeBonus: "Up to 70,000 MR points",
        minIncome: 20000,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 2.2,
        foreignFee: 2.5
    },
    {
        id: 6,
        name: "American Express Platinum Card",
        issuer: "American Express",
        annualFee: 799,
        earnRate: "2x MR points on dining and travel",
        welcomeBonus: "Up to 110,000 MR points",
        minIncome: 0,
        tier: "S",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 2.2,
        foreignFee: 2.5
    },
    {
        id: 7,
        name: "American Express Aeroplan Business Reserve Card",
        issuer: "American Express",
        annualFee: 599,
        earnRate: "3x Aeroplan points on Air Canada",
        welcomeBonus: "Up to 95,000 Aeroplan points",
        minIncome: 0,
        tier: "S",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 2.1,
        foreignFee: 2.5
    },
    {
        id: 8,
        name: "RBC® Avion Visa Infinite†",
        issuer: "RBC",
        annualFee: 120,
        earnRate: "1x Avion point on all purchases",
        welcomeBonus: "Up to 55,000 Avion Points",
        minIncome: 60000,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 9,
        name: "CIBC Aventura® Visa* Card for Business",
        issuer: "CIBC",
        annualFee: 120,
        earnRate: "1.5x Aventura points on travel",
        welcomeBonus: "Up to 70,000 Aventura Points",
        minIncome: 35000,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 1.25,
        foreignFee: 2.5
    },
    {
        id: 10,
        name: "TD® Aeroplan® Visa Infinite Privilege* Card",
        issuer: "TD",
        annualFee: 599,
        earnRate: "2x Aeroplan points on Air Canada",
        welcomeBonus: "Up to 85,000 Aeroplan points",
        minIncome: 150000,
        tier: "S",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 2.1,
        foreignFee: 2.5
    },
    {
        id: 11,
        name: "American Express Aeroplan Reserve Card",
        issuer: "American Express",
        annualFee: 599,
        earnRate: "3x Aeroplan points on Air Canada",
        welcomeBonus: "Up to 85,000 Aeroplan points",
        minIncome: 0,
        tier: "S",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 2.1,
        foreignFee: 2.5
    },
    {
        id: 12,
        name: "American Express Business Gold Rewards Card",
        issuer: "American Express",
        annualFee: 199,
        earnRate: "1x MR points on all purchases",
        welcomeBonus: "Up to 40,000 MR points",
        minIncome: 0,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 2.2,
        foreignFee: 2.5
    },
    {
        id: 13,
        name: "RBC® Avion Visa Infinite Privilege†",
        issuer: "RBC",
        annualFee: 399,
        earnRate: "1.25x Avion points on all purchases",
        welcomeBonus: "Up to 70,000 Avion points",
        minIncome: 150000,
        tier: "S",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 2.0,
        foreignFee: 2.5
    },
    {
        id: 14,
        name: "BMO Ascend World Elite®* Mastercard®*",
        issuer: "BMO",
        annualFee: 150,
        earnRate: "5x BMO Rewards on travel",
        welcomeBonus: "Up to 100,000 BMO Rewards points",
        minIncome: 80000,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 0.67,
        foreignFee: 2.5
    },
    {
        id: 15,
        name: "BMO VIPorter World Elite®* Mastercard®*",
        issuer: "BMO",
        annualFee: 199,
        earnRate: "3x points on Porter Airlines",
        welcomeBonus: "Up to 70,000 VIPorter points",
        minIncome: 80000,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 0.67,
        foreignFee: 2.5
    },
    {
        id: 16,
        name: "RBC Avion Visa Infinite Business",
        issuer: "RBC",
        annualFee: 175,
        earnRate: "1x Avion point on all purchases",
        welcomeBonus: "35,000 Avion points upon approval",
        minIncome: 0,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 17,
        name: "TD® Aeroplan® Visa Infinite* Card",
        issuer: "TD",
        annualFee: 139,
        earnRate: "1.5x Aeroplan points on gas and grocery",
        welcomeBonus: "Up to 40,000 Aeroplan points",
        minIncome: 60000,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 2.1,
        foreignFee: 2.5
    },
    {
        id: 18,
        name: "BMO® Ascend World Elite®* Business Mastercard®*",
        issuer: "BMO",
        annualFee: 150,
        earnRate: "4x points on office supplies",
        welcomeBonus: "Up to 100,000 BMO Rewards points",
        minIncome: 80000,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 0.67,
        foreignFee: 2.5
    },
    {
        id: 19,
        name: "Marriott Bonvoy Business American Express Card",
        issuer: "American Express",
        annualFee: 150,
        earnRate: "5x points at Marriott properties",
        welcomeBonus: "Up to 110,000 Bonvoy points",
        minIncome: 0,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 0.9,
        foreignFee: 2.5
    },
    {
        id: 20,
        name: "CIBC Aventura® Visa Infinite* Card",
        issuer: "CIBC",
        annualFee: 139,
        earnRate: "2x points on travel booked via CIBC",
        welcomeBonus: "Up to 60,000 Aventura Points",
        minIncome: 60000,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 1.25,
        foreignFee: 2.5
    },
    {
        id: 21,
        name: "Marriott Bonvoy American Express Card",
        issuer: "American Express",
        annualFee: 120,
        earnRate: "5x points at Marriott properties",
        welcomeBonus: "Up to 110,000 Bonvoy points",
        minIncome: 15000,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 0.9,
        foreignFee: 2.5
    },
    {
        id: 22,
        name: "Scotiabank Passport® Visa Infinite Privilege* Card",
        issuer: "Scotiabank",
        annualFee: 599,
        earnRate: "3x Scene+ points on Sobeys/Safeway",
        welcomeBonus: "Up to 100,000 Scene+ points",
        minIncome: 150000,
        tier: "S",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 0
    },
    {
        id: 23,
        name: "CIBC Aventura® Gold Visa* Card",
        issuer: "CIBC",
        annualFee: 139,
        earnRate: "2x points on travel booked via CIBC",
        welcomeBonus: "Up to 60,000 Aventura Points",
        minIncome: 15000,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 2.2,
        foreignFee: 2.5
    },
    {
        id: 24,
        name: "CIBC Aeroplan® Visa Infinite Privilege* Card",
        issuer: "CIBC",
        annualFee: 599,
        earnRate: "2x Aeroplan points on Air Canada",
        welcomeBonus: "Up to 100,000 Aeroplan points",
        minIncome: 150000,
        tier: "S",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 2.1,
        foreignFee: 2.5
    },
    {
        id: 25,
        name: "RBC® Avion Visa Platinum†",
        issuer: "RBC",
        annualFee: 120,
        earnRate: "1x Avion point on all purchases",
        welcomeBonus: "Up to 55,000 Avion Points",
        minIncome: 0,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 2.2,
        foreignFee: 2.5
    },
    {
        id: 26,
        name: "RBC Avion Visa Business",
        issuer: "RBC",
        annualFee: 120,
        earnRate: "1x Avion point on all purchases",
        welcomeBonus: "35,000 RBC Avion points",
        minIncome: 0,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 27,
        name: "American Express Aeroplan Card",
        issuer: "American Express",
        annualFee: 120,
        earnRate: "2x Aeroplan points on Air Canada",
        welcomeBonus: "Up to 40,000 Aeroplan points",
        minIncome: 15000,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 2.1,
        foreignFee: 2.5
    },
    {
        id: 28,
        name: "BMO eclipse Visa Infinite* Card",
        issuer: "BMO",
        annualFee: 120,
        earnRate: "5x BMO Rewards on dining and groceries",
        welcomeBonus: "Total of 70,000 BMO Rewards points",
        minIncome: 60000,
        tier: "A",
        category: "rewards",
        studentFriendly: false,
        typicalCPP: 0.67,
        foreignFee: 2.5
    },
    {
        id: 29,
        name: "CIBC Aeroplan® Visa Infinite* Card",
        issuer: "CIBC",
        annualFee: 139,
        earnRate: "1.5x Aeroplan points on gas and groceries",
        welcomeBonus: "Up to 45,000 Aeroplan points",
        minIncome: 60000,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 2.1,
        foreignFee: 2.5
    },
    {
        id: 30,
        name: "WestJet RBC® World Elite Mastercardǂ",
        issuer: "RBC",
        annualFee: 139,
        earnRate: "2% back in WestJet dollars on flights",
        welcomeBonus: "Up to 70,000 WestJet points",
        minIncome: 80000,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 31,
        name: "BMO CashBack® World Elite®* Mastercard®*",
        issuer: "BMO",
        annualFee: 120,
        earnRate: "5% cash back on groceries",
        welcomeBonus: "Up to $480 cash back",
        minIncome: 80000,
        tier: "A",
        category: "cashback",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 32,
        name: "Scotiabank Passport® Visa Infinite* Card",
        issuer: "Scotiabank",
        annualFee: 150,
        earnRate: "3x Scene+ points on Sobeys/Safeway",
        welcomeBonus: "Up to 60,000 Scene+ points",
        minIncome: 60000,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 0
    },
    {
        id: 33,
        name: "BMO VIPorter Mastercard®*",
        issuer: "BMO",
        annualFee: 89,
        earnRate: "3x points on Porter Airlines",
        welcomeBonus: "Up to 40,000 VIPorter points",
        minIncome: 15000,
        tier: "B",
        category: "travel",
        studentFriendly: true,
        typicalCPP: 0.67,
        foreignFee: 2.5
    },
    {
        id: 34,
        name: "Scotiabank Gold American Express® Card",
        issuer: "American Express",
        annualFee: 120,
        earnRate: "6x Scene+ points on Sobeys/Safeway",
        welcomeBonus: "Up to 45,000 Scene+ points",
        minIncome: 12000,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 2.2,
        foreignFee: 0
    },
    {
        id: 35,
        name: "RBC® ION+ Visa",
        issuer: "RBC",
        annualFee: 48,
        earnRate: "3x Avion on grocery, dining, gas",
        welcomeBonus: "Up to 21,000 Avion points",
        minIncome: 0,
        tier: "B",
        category: "rewards",
        studentFriendly: true,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 36,
        name: "TD Cash Back Visa Infinite* Card",
        issuer: "TD",
        annualFee: 139,
        earnRate: "3% cash back on groceries and gas",
        welcomeBonus: "10% cash back in first 3 months",
        minIncome: 60000,
        tier: "A",
        category: "cashback",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 37,
        name: "Cathay World Elite® Mastercard® – powered by Neo",
        issuer: "Neo Financial",
        annualFee: 180,
        earnRate: "2x Asia Miles on Cathay Pacific",
        welcomeBonus: "Up to 30,000 Asia Miles",
        minIncome: 80000,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 38,
        name: "American Express Cobalt Card",
        issuer: "American Express",
        annualFee: 192,
        earnRate: "5x points on eats and drinks",
        welcomeBonus: "Up to 15,000 MR points",
        minIncome: 0,
        tier: "A",
        category: "rewards",
        studentFriendly: false,
        typicalCPP: 2.2,
        foreignFee: 2.5
    },
    {
        id: 39,
        name: "TD® Aeroplan® Visa Platinum* Card",
        issuer: "TD",
        annualFee: 89,
        earnRate: "1x Aeroplan point on gas and grocery",
        welcomeBonus: "Up to 15,000 Aeroplan points",
        minIncome: 0,
        tier: "B",
        category: "travel",
        studentFriendly: true,
        typicalCPP: 2.1,
        foreignFee: 2.5
    },
    {
        id: 40,
        name: "CIBC Dividend® Visa Infinite* Card",
        issuer: "CIBC",
        annualFee: 120,
        earnRate: "4% cash back on gas and groceries",
        welcomeBonus: "10% cash back welcome bonus",
        minIncome: 60000,
        tier: "A",
        category: "cashback",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 41,
        name: "CIBC Aventura® Visa Infinite Privilege* Card",
        issuer: "CIBC",
        annualFee: 499,
        earnRate: "3x points on travel booked via CIBC",
        welcomeBonus: "Up to 80,000 Aventura Points",
        minIncome: 150000,
        tier: "S",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 1.25,
        foreignFee: 2.5
    },
    {
        id: 42,
        name: "Scotiabank Platinum American Express® Card",
        issuer: "American Express",
        annualFee: 399,
        earnRate: "2x Scene+ points on everything",
        welcomeBonus: "Up to 80,000 Scene+ points",
        minIncome: 12000,
        tier: "S",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 2.2,
        foreignFee: 0
    },
    {
        id: 43,
        name: "TD Platinum Travel Visa* Card",
        issuer: "TD",
        annualFee: 89,
        earnRate: "5x points on Expedia for TD",
        welcomeBonus: "Up to 50,000 TD Rewards Points",
        minIncome: 0,
        tier: "B",
        category: "travel",
        studentFriendly: true,
        typicalCPP: 2.2,
        foreignFee: 2.5
    },
    {
        id: 44,
        name: "CIBC Dividend Platinum® Visa* Card",
        issuer: "CIBC",
        annualFee: 99,
        earnRate: "3% cash back on gas and groceries",
        welcomeBonus: "10% cash back welcome bonus",
        minIncome: 15000,
        tier: "B",
        category: "cashback",
        studentFriendly: false,
        typicalCPP: 2.2,
        foreignFee: 2.5
    },
    {
        id: 45,
        name: "American Express Green Card",
        issuer: "American Express",
        annualFee: 0,
        earnRate: "1x MR points on all purchases",
        welcomeBonus: "10,000 MR points",
        minIncome: 0,
        tier: "C",
        category: "rewards",
        studentFriendly: true,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 46,
        name: "RBC® ION Visa",
        issuer: "RBC",
        annualFee: 0,
        earnRate: "1.5x Avion on grocery, ride, gas",
        welcomeBonus: "Up to 11,000 Avion points",
        minIncome: 0,
        tier: "C",
        category: "rewards",
        studentFriendly: true,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 47,
        name: "Scotia Momentum® Visa Infinite* Card",
        issuer: "Scotiabank",
        annualFee: 120,
        earnRate: "4% cash back on groceries and bills",
        welcomeBonus: "10% cash back in first 3 months",
        minIncome: 60000,
        tier: "A",
        category: "cashback",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 48,
        name: "MBNA Rewards World Elite® Mastercard®",
        issuer: "MBNA",
        annualFee: 120,
        earnRate: "5x points on groceries and dining",
        welcomeBonus: "Total of 30,000 MBNA Rewards points",
        minIncome: 80000,
        tier: "A",
        category: "rewards",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 49,
        name: "BMO eclipse Visa Infinite Privilege* Card",
        issuer: "BMO",
        annualFee: 599,
        earnRate: "5x BMO Rewards on most categories",
        welcomeBonus: "Up to 200,000 BMO Rewards points",
        minIncome: 150000,
        tier: "S",
        category: "rewards",
        studentFriendly: false,
        typicalCPP: 0.67,
        foreignFee: 2.5
    },
    {
        id: 50,
        name: "Scotiabank Passport® Visa Infinite Business* Card",
        issuer: "Scotiabank",
        annualFee: 199,
        earnRate: "1.5x Scene+ points on business spend",
        welcomeBonus: "Up to 40,000 Scene+ points",
        minIncome: 0,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 0
    },
    {
        id: 51,
        name: "WestJet RBC® World Elite Mastercard for Businessǂ",
        issuer: "RBC",
        annualFee: 175,
        earnRate: "2% back in WestJet dollars on flights",
        welcomeBonus: "35,000 WestJet points",
        minIncome: 80000,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 52,
        name: "BMO CashBack® Business Mastercard®*",
        issuer: "BMO",
        annualFee: 0,
        earnRate: "1.5% cash back on gas and office",
        welcomeBonus: "10% cash back in first 3 months",
        minIncome: 0,
        tier: "C",
        category: "cashback",
        studentFriendly: true,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 53,
        name: "RBC® Cash Back Preferred World Elite Mastercard",
        issuer: "RBC",
        annualFee: 99,
        earnRate: "1.5% cash back on all purchases",
        welcomeBonus: "N/A",
        minIncome: 80000,
        tier: "B",
        category: "cashback",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 54,
        name: "CIBC Dividend® Visa* Card for Students",
        issuer: "CIBC",
        annualFee: 0,
        earnRate: "2% cash back on groceries",
        welcomeBonus: "10% cash back welcome bonus",
        minIncome: 0,
        tier: "C",
        category: "cashback",
        studentFriendly: true,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 55,
        name: "BMO CashBack® Mastercard®*",
        issuer: "BMO",
        annualFee: 0,
        earnRate: "3% cash back on groceries",
        welcomeBonus: "5% cash back in first 3 months",
        minIncome: 15000,
        tier: "C",
        category: "cashback",
        studentFriendly: true,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 56,
        name: "WestJet RBC® Mastercard",
        issuer: "RBC",
        annualFee: 39,
        earnRate: "1.5% back in WestJet dollars on flights",
        welcomeBonus: "Up to 15,000 WestJet points",
        minIncome: 0,
        tier: "B",
        category: "travel",
        studentFriendly: true,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 57,
        name: "Tangerine® Money-Back World Mastercard®*",
        issuer: "Tangerine",
        annualFee: 0,
        earnRate: "2% cash back in 2 categories",
        welcomeBonus: "$120 cash back",
        minIncome: 60000,
        tier: "C",
        category: "cashback",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 58,
        name: "Scotiabank® Scene+™ Visa* Card",
        issuer: "Scotiabank",
        annualFee: 0,
        earnRate: "2x Scene+ points on Sobeys/Cineplex",
        welcomeBonus: "Up to 10,000 Scene+ points",
        minIncome: 0,
        tier: "C",
        category: "rewards",
        studentFriendly: true,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 59,
        name: "CIBC Aeroplan® Visa* Card",
        issuer: "CIBC",
        annualFee: 0,
        earnRate: "1x Aeroplan point on gas and grocery",
        welcomeBonus: "Up to 10,000 Aeroplan points",
        minIncome: 0,
        tier: "C",
        category: "travel",
        studentFriendly: true,
        typicalCPP: 2.1,
        foreignFee: 2.5
    },
    {
        id: 60,
        name: "MBNA Rewards Platinum Plus® Mastercard®",
        issuer: "MBNA",
        annualFee: 0,
        earnRate: "4x points on restaurant/grocery",
        welcomeBonus: "Up to 10,000 MBNA Rewards points",
        minIncome: 0,
        tier: "C",
        category: "rewards",
        studentFriendly: true,
        typicalCPP: 2.2,
        foreignFee: 2.5
    },
    {
        id: 61,
        name: "Scotia Momentum® No-Fee Visa* Card",
        issuer: "Scotiabank",
        annualFee: 0,
        earnRate: "1% cash back on gas and grocery",
        welcomeBonus: "5% cash back in first 3 months",
        minIncome: 0,
        tier: "C",
        category: "cashback",
        studentFriendly: true,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 62,
        name: "Tangerine Money-Back Mastercard",
        issuer: "Tangerine",
        annualFee: 0,
        earnRate: "2% cash back in 2 categories",
        welcomeBonus: "10% cash back in first 2 months",
        minIncome: 12000,
        tier: "C",
        category: "cashback",
        studentFriendly: true,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 63,
        name: "Simplii Financial™ Cash Back Visa* Card",
        issuer: "Simplii Financial",
        annualFee: 0,
        earnRate: "4% cash back on restaurants",
        welcomeBonus: "20% cash back for first 3 months",
        minIncome: 15000,
        tier: "C",
        category: "cashback",
        studentFriendly: true,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 64,
        name: "SimplyCash Card from American Express",
        issuer: "American Express",
        annualFee: 0,
        earnRate: "1.25% cash back on all purchases",
        welcomeBonus: "Up to $100 cash back",
        minIncome: 0,
        tier: "C",
        category: "cashback",
        studentFriendly: true,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 65,
        name: "CIBC Aventura® Visa* Card for Students",
        issuer: "CIBC",
        annualFee: 0,
        earnRate: "1x point on travel/gas/grocery",
        welcomeBonus: "Up to 10,000 Aventura Points",
        minIncome: 0,
        tier: "C",
        category: "travel",
        studentFriendly: true,
        typicalCPP: 1.25,
        foreignFee: 2.5
    },
    {
        id: 66,
        name: "CIBC Aventura® Visa* Card",
        issuer: "CIBC",
        annualFee: 0,
        earnRate: "1x point on travel/gas/grocery",
        welcomeBonus: "Up to 10,000 Aventura Points",
        minIncome: 0,
        tier: "C",
        category: "travel",
        studentFriendly: true,
        typicalCPP: 1.25,
        foreignFee: 2.5
    },
    {
        id: 67,
        name: "SimplyCash Preferred Card from American Express",
        issuer: "American Express",
        annualFee: 120,
        earnRate: "2% cash back on all purchases",
        welcomeBonus: "Total of $200 cash back",
        minIncome: 0,
        tier: "A",
        category: "cashback",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 68,
        name: "TD Rewards Visa* Card",
        issuer: "TD",
        annualFee: 0,
        earnRate: "1x point on grocery/restaurant",
        welcomeBonus: "15,152 TD Rewards Points",
        minIncome: 0,
        tier: "C",
        category: "rewards",
        studentFriendly: true,
        typicalCPP: 0.5,
        foreignFee: 2.5
    },
    {
        id: 69,
        name: "RBC® Cash Back Mastercard",
        issuer: "RBC",
        annualFee: 0,
        earnRate: "2% cash back on groceries",
        welcomeBonus: "N/A",
        minIncome: 0,
        tier: "C",
        category: "cashback",
        studentFriendly: true,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 70,
        name: "Scotiabank American Express® Card",
        issuer: "American Express",
        annualFee: 0,
        earnRate: "1x Scene+ point on all purchases",
        welcomeBonus: "Up to 5,000 Scene+ points",
        minIncome: 0,
        tier: "C",
        category: "rewards",
        studentFriendly: true,
        typicalCPP: 1.0,
        foreignFee: 0
    },
    {
        id: 71,
        name: "PC Financial World Elite Mastercard",
        issuer: "PC Financial",
        annualFee: 0,
        earnRate: "30 pts/dollar at Loblaws",
        welcomeBonus: "20,000 PC Optimum points",
        minIncome: 80000,
        tier: "B",
        category: "rewards",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 72,
        name: "CIBC Costco Mastercard",
        issuer: "CIBC",
        annualFee: 0,
        earnRate: "3% cash back at restaurants",
        welcomeBonus: "N/A",
        minIncome: 0,
        tier: "C",
        category: "cashback",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 73,
        name: "TD Cash Back Visa* Card",
        issuer: "TD",
        annualFee: 0,
        earnRate: "1% cash back on gas/grocery",
        welcomeBonus: "No signup bonus",
        minIncome: 0,
        tier: "C",
        category: "cashback",
        studentFriendly: true,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 74,
        name: "Rogers Red Mastercard®",
        issuer: "Rogers Bank",
        annualFee: 0,
        earnRate: "2% cash back for Rogers customers",
        welcomeBonus: "N/A",
        minIncome: 0,
        tier: "C",
        category: "cashback",
        studentFriendly: true,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 75,
        name: "Rogers Red World Elite® Mastercard®",
        issuer: "Rogers Bank",
        annualFee: 0,
        earnRate: "3% cash back on USD purchases",
        welcomeBonus: "N/A",
        minIncome: 80000,
        tier: "B",
        category: "cashback",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 76,
        name: "Laurentian Bank Visa Infinite Card",
        issuer: "Laurentian Bank",
        annualFee: 130,
        earnRate: "Points on recurring bills",
        welcomeBonus: "Up to 12,000 bonus points",
        minIncome: 60000,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 77,
        name: "Desjardins Cash Back Mastercard",
        issuer: "Desjardins",
        annualFee: 0,
        earnRate: "2% cash back on restaurants",
        welcomeBonus: "N/A",
        minIncome: 0,
        tier: "C",
        category: "cashback",
        studentFriendly: true,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 78,
        name: "Desjardins Cash Back World Elite Mastercard",
        issuer: "Desjardins",
        annualFee: 100,
        earnRate: "4% cash back on groceries",
        welcomeBonus: "N/A",
        minIncome: 80000,
        tier: "A",
        category: "cashback",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 79,
        name: "CIBC Select Visa* Card",
        issuer: "CIBC",
        annualFee: 29,
        earnRate: "N/A (Low interest card)",
        welcomeBonus: "N/A",
        minIncome: 15000,
        tier: "C",
        category: "low_interest",
        studentFriendly: true,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 80,
        name: "CIBC Dividend® Visa* Card",
        issuer: "CIBC",
        annualFee: 0,
        earnRate: "1% cash back on gas/grocery",
        welcomeBonus: "No signup bonus",
        minIncome: 0,
        tier: "C",
        category: "cashback",
        studentFriendly: true,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 81,
        name: "Neo World Elite® Mastercard",
        issuer: "Neo Financial",
        annualFee: 125,
        earnRate: "Variable cash back at partners",
        welcomeBonus: "No welcome bonus",
        minIncome: 80000,
        tier: "A",
        category: "cashback",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 82,
        name: "Canadian Tire Triangle World Elite Mastercard",
        issuer: "Canadian Tire",
        annualFee: 0,
        earnRate: "4% CT Money at Canadian Tire",
        welcomeBonus: "No welcome bonus",
        minIncome: 80000,
        tier: "B",
        category: "rewards",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 83,
        name: "Home Trust Preferred Visa Card",
        issuer: "Home Trust",
        annualFee: 0,
        earnRate: "1% cash back on all purchases",
        welcomeBonus: "N/A",
        minIncome: 0,
        tier: "C",
        category: "cashback",
        studentFriendly: true,
        typicalCPP: 1.0,
        foreignFee: 0
    },
    {
        id: 84,
        name: "Brim Mastercard",
        issuer: "Brim Financial",
        annualFee: 0,
        earnRate: "1 point per $1 spent",
        welcomeBonus: "No welcome bonus",
        minIncome: 0,
        tier: "C",
        category: "rewards",
        studentFriendly: true,
        typicalCPP: 1.0,
        foreignFee: 0
    },
    {
        id: 85,
        name: "Brim World Mastercard",
        issuer: "Brim Financial",
        annualFee: 99,
        earnRate: "1.5 points per $1 spent",
        welcomeBonus: "No welcome bonus",
        minIncome: 60000,
        tier: "B",
        category: "rewards",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 0
    },
    {
        id: 86,
        name: "Brim World Elite Mastercard",
        issuer: "Brim Financial",
        annualFee: 199,
        earnRate: "2 points per $1 spent",
        welcomeBonus: "No welcome bonus",
        minIncome: 80000,
        tier: "A",
        category: "rewards",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 0
    },
    {
        id: 87,
        name: "MBNA True Line® Mastercard",
        issuer: "MBNA",
        annualFee: 0,
        earnRate: "N/A (Low interest card)",
        welcomeBonus: "No signup bonus",
        minIncome: 0,
        tier: "C",
        category: "low_interest",
        studentFriendly: true,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 88,
        name: "Air France KLM World Elite Mastercard®",
        issuer: "Brim Financial",
        annualFee: 132,
        earnRate: "Points on Air France/KLM",
        welcomeBonus: "60 XP",
        minIncome: 80000,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 89,
        name: "National Bank® World Elite® Mastercard®",
        issuer: "National Bank",
        annualFee: 150,
        earnRate: "5x points on grocery and restaurant",
        welcomeBonus: "Up to 35,000 points",
        minIncome: 80000,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 0.9,
        foreignFee: 2.5
    },
    {
        id: 90,
        name: "BMO eclipse rise Visa* Card",
        issuer: "BMO",
        annualFee: 0,
        earnRate: "5x points on groceries and dining",
        welcomeBonus: "Up to 25,000 BMO Rewards points",
        minIncome: 0,
        tier: "C",
        category: "rewards",
        studentFriendly: true,
        typicalCPP: 0.67,
        foreignFee: 2.5
    },
    {
        id: 91,
        name: "Meridian Visa Infinite* Cash Back Card",
        issuer: "Meridian Credit Union",
        annualFee: 0,
        earnRate: "4% cash back on gas/grocery",
        welcomeBonus: "No signup bonus",
        minIncome: 60000,
        tier: "B",
        category: "cashback",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 92,
        name: "Neo World Mastercard®",
        issuer: "Neo Financial",
        annualFee: 0,
        earnRate: "Variable cash back at partners",
        welcomeBonus: "No welcome bonus",
        minIncome: 0,
        tier: "C",
        category: "cashback",
        studentFriendly: true,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 93,
        name: "Meridian Visa Infinite* Travel Rewards Card",
        issuer: "Meridian Credit Union",
        annualFee: 0,
        earnRate: "1.5 points on all purchases",
        welcomeBonus: "No signup bonus",
        minIncome: 60000,
        tier: "B",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 94,
        name: "Desjardins Odyssey Gold Visa",
        issuer: "Desjardins",
        annualFee: 110,
        earnRate: "Points on active transportation",
        welcomeBonus: "N/A",
        minIncome: 0,
        tier: "B",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 2.2,
        foreignFee: 2.5
    },
    {
        id: 95,
        name: "Desjardins Odyssey World Elite Mastercard",
        issuer: "Desjardins",
        annualFee: 130,
        earnRate: "3% back in BONUSDOLLARS on groceries",
        welcomeBonus: "N/A",
        minIncome: 80000,
        tier: "A",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 2.5
    },
    {
        id: 96,
        name: "Desjardins Odyssey Visa Infinite Privilege",
        issuer: "Desjardins",
        annualFee: 395,
        earnRate: "4% back in BONUSDOLLARS on travel",
        welcomeBonus: "N/A",
        minIncome: 150000,
        tier: "S",
        category: "travel",
        studentFriendly: false,
        typicalCPP: 1.0,
        foreignFee: 2.5
    }
];

// Glossary terms
export const GLOSSARY_TERMS = [
    {
        term: "CPP (Cents Per Point)",
        definition:
            "The actual cash value of each rewards point. Calculated as (Cash Value ÷ Points Used) × 100.",
        whyMatters:
            "A redemption worth 2 CPP gives you twice the value compared to 1 CPP. This helps you maximize rewards.",
        example:
            "If you redeem 25,000 points for a $500 flight, that's 2 CPP - excellent value!",
    },
    {
        term: "Annual Fee",
        definition:
            "A yearly charge for having the credit card, ranging from $0 to $500+.",
        whyMatters:
            "You need to earn enough rewards to offset this cost. A $120 fee means you need $120+ in rewards to break even.",
        example:
            "If a card has a $95 fee but you earn $300 in rewards yearly, your net benefit is $205.",
    },
    {
        term: "APR (Annual Percentage Rate)",
        definition: "The yearly interest rate charged on unpaid balances.",
        whyMatters:
            "If you carry a balance, high APR (19-29%) can quickly erase any rewards earned. Always pay in full if possible.",
        example: "A $1,000 balance at 20% APR costs you $200 per year in interest.",
    },
    {
        term: "Welcome Bonus",
        definition:
            "A one-time reward for new cardholders who meet minimum spending requirements within 3-6 months.",
        whyMatters:
            "This can provide $300-800+ in value, but only if you can hit the spending requirement naturally.",
        example:
            "Earn 50,000 points after spending $3,000 in 3 months (worth $500-1,000 depending on redemption).",
    },
    {
        term: "Foreign Transaction Fee",
        definition:
            "A fee (typically 2.5%) charged when you make purchases in foreign currency.",
        whyMatters:
            "Adds up quickly when traveling. A $1,000 trip costs an extra $25 with this fee.",
        example:
            "Travel cards often waive this fee, saving frequent travelers hundreds per year.",
    },
    {
        term: "Minimum Spend Requirement",
        definition:
            "The amount you must spend within a set period to earn a welcome bonus.",
        whyMatters:
            "Never overspend just to hit this target - only apply if it matches your natural spending.",
        example: "Spend $3,000 in 90 days to earn the bonus. That's $1,000/month.",
    },
    {
        term: "Grace Period",
        definition:
            "The interest-free period (usually 21 days) between your statement date and payment due date.",
        whyMatters:
            "Pay your full balance by the due date to avoid any interest charges.",
        example:
            "Statement closes Jan 1, payment due Jan 21. Pay in full by Jan 21 = no interest.",
    },
    {
        term: "Credit Utilization",
        definition:
            "The percentage of your available credit that you're using. Keep it below 30% for best credit score.",
        whyMatters:
            "Using $900 of a $1,000 limit (90%) hurts your score. Using $300 (30%) is healthy.",
        example:
            "If your limit is $2,000, keep your balance below $600 to maintain good credit health.",
    },
];

// Quiz questions
export const QUIZ_QUESTIONS = [
    {
        id: 1,
        question: "What's your average monthly spending?",
        options: [
            { value: "low", label: "Under $500" },
            { value: "medium", label: "$500 - $2,000" },
            { value: "high", label: "$2,000 - $5,000" },
            { value: "very-high", label: "Over $5,000" },
        ],
    },
    {
        id: 2,
        question: "Where do you spend the most?",
        options: [
            { value: "groceries", label: "Groceries & Dining" },
            { value: "gas", label: "Gas & Transportation" },
            { value: "travel", label: "Travel & Hotels" },
            { value: "online", label: "Online Shopping" },
            { value: "mixed", label: "Pretty evenly spread" },
        ],
    },
    {
        id: 3,
        question: "Do you carry a balance month-to-month?",
        options: [
            { value: "never", label: "No, I always pay in full" },
            { value: "sometimes", label: "Sometimes" },
            { value: "usually", label: "Yes, usually" },
        ],
    },
    {
        id: 4,
        question: "How often do you travel internationally?",
        options: [
            { value: "never", label: "Never or rarely" },
            { value: "once", label: "Once a year" },
            { value: "multiple", label: "2-3 times per year" },
            { value: "frequent", label: "4+ times per year" },
        ],
    },
    {
        id: 5,
        question: "What's your current annual income?",
        options: [
            { value: "student", label: "Under $15,000 (student/part-time)" },
            { value: "entry", label: "$15,000 - $40,000" },
            { value: "mid", label: "$40,000 - $80,000" },
            { value: "high", label: "$80,000+" },
        ],
    },
];